import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { UserManagementService } from "../services/user-management.service";
import { UserViewModel } from "../models/user-view-model";
import { UserDataStoreService } from "../services/user-data-store.service";
import { UserViewComponent } from "./user-view/user-view.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { PermissionEnum } from '../services/guards/permissions';
import { SearchFilterModel } from '../models/search-filter-model';
import { PagedResponse } from '../models/paged-response';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent implements OnInit {

  public dtOptions: DataTables.Settings = {};
  public users: UserViewModel[] = [];
  public dtTrigger: Subject<boolean> = new Subject();
  public canEdit: boolean;
  public admin: boolean;
  public globalSearch: boolean;
  public canDoGlobalSearch: boolean;
  public canAdd: boolean;

  public filter: SearchFilterModel = {
    search: '',
    take: 10,
    skip: 0,
    orderBy: null,
    orderDirection: 'ASC'
  };

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  private subscription: Subscription;

  constructor(private _userDataStore: UserDataStoreService, private _userManagementService: UserManagementService, private _modalService: NgbModal) {

    this._userDataStore.currentUser.subscribe(user => {
      if (!!this._userDataStore) {
        this.canDoGlobalSearch = this._userDataStore.hasRequiredPermissions([PermissionEnum.GlobalUserSearch], []);
        this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddUser], []);
        this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditUser], []);
      }
    });

  }

  ngOnInit() {
    this.dtOptions = {
      pageLength: this.filter.take,
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      ajax: async (dataTablesParameters: any, callback) => {
        this.filter.search = dataTablesParameters.search.value;
        this.filter.take = dataTablesParameters.length;
        this.filter.skip = dataTablesParameters.start;
        this.filter.orderDirection = dataTablesParameters.order[0].dir;
        this.filter.orderBy = dataTablesParameters.columns[dataTablesParameters.order[0].column].data;
        let result: PagedResponse<UserViewModel>;
        if (this.globalSearch) {
          result = (await this._userManagementService.GetPagedUsers(this.filter));
        } else {
          result = (await this._userManagementService.GetPagedParticipantUsers(this.filter));
        }
        this.users = result.response;
        callback({
          recordsTotal: result.total,
          recordsFiltered: result.total,
          data: []
        });
      },
      responsive: true,
      columns: [
        { name: 'Name', data: 'Name' },
        { name: 'Email', data: 'Email' },
        { name: 'Active', data: 'Active' },
        { name:'Actions', data: 'actions', orderable: false }
      ]
    };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    this.subscription = this._userDataStore.selectedParticipantObservable.subscribe(async () => {
      this.resetDatatable();
    });
  }


  private resetDatatable(): void {
    this.filter = {
      search: '',
      take: 10,
      skip: 0,
      orderBy: null,
      orderDirection: 'ASC'
    };
    //Added a "?" on the below line 61 to check if an object exists
    this.dtElement.dtInstance?.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public async  addNewUser(): Promise<void> {
    const modalRef = this._modalService.open(UserViewComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    await modalRef.result;
    //this.users = await this._userManagementService.GetParticipantUsers();
    this.users = null;
    if (this.globalSearch) {
      this.users = await this._userManagementService.GetAllUsers();
    } else {
      this.users = await this._userManagementService.GetParticipantUsers();
    }
    this.resetDatatable();
  }

  public async updateUser(user: UserViewModel): Promise<void> {

    const modalRef = this._modalService.open(UserViewComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.user = user;
    await modalRef.result;
    //this.users = await this._userManagementService.GetParticipantUsers();
    if (this.globalSearch) {
      this.users = await this._userManagementService.GetAllUsers();
    } else {
      this.users = await this._userManagementService.GetParticipantUsers();
    }
    this.resetDatatable();
  }

  public async SetGlobalSearch(value): Promise<void> {
    this.globalSearch = value.target.checked;
    this.resetDatatable();
  }


  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.subscription.unsubscribe();
  }

}
